import { render, staticRenderFns } from "./artificial.vue?vue&type=template&id=36de328c&scoped=true"
import script from "./artificial.vue?vue&type=script&lang=ts"
export * from "./artificial.vue?vue&type=script&lang=ts"
import style0 from "./artificial.vue?vue&type=style&index=0&id=36de328c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de328c",
  null
  
)

export default component.exports